import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import Cookies from 'js-cookie';
import { fetchUser } from '../features/auth/userSlice';
import ScrollToTop from "../components/ui/ScrollToTop";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { fetchFavorites } from '../features/home/favSlice';
import { fetchSetting } from '../features/admin/settingSlice';

import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import { updateFirebaseToken } from '../features/auth/loginSlice';
import NotificationPopup from '../components/ui/NotificationPopup';

function App() {
    const { i18n } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: RootState) => state.user);
    const [notif, setNotif] = useState<{ title: string; body: string } | null>(null);

    const userId = Cookies.get('userId');

    useEffect(() => {
        dispatch(fetchSetting());
        if (!user && userId) {
            dispatch(fetchUser(userId));
        }
    }, [dispatch, user, userId]);

    useEffect(() => {
        if (userId && user?.role?.toLowerCase() !== 'admin') {
            dispatch(fetchFavorites({ id: userId }));
        }
    }, [dispatch, userId, user]);

useEffect(() => {
  if (userId) {
    if (typeof Notification !== "undefined" && Notification.requestPermission) {
      Notification.requestPermission()
        .then((permission) => {
          if (permission === "granted") {
            getToken(messaging, {
              vapidKey:
                "BDGuqSFM1_E7t54oZwyZBAFTS9ZSZ93GKkbkOwxHlf_z25MEcg-LepMvk-ploUrQZO3Mkdip92pSd1EIziH-sdg",
            })
              .then((token) => {
                console.log("FCM Token:", token);
                const payload = { userId, token };
                dispatch(updateFirebaseToken(payload));
              })
              .catch((err) => console.error("FCM Token error:", err));
          }
        })
        .catch((err) => console.error("Notification permission error:", err));
    } else {
      console.warn("Notifications are not supported in this browser.");
    }
  }

  onMessage(messaging, (payload) => {
    console.log("Message received: ", payload);
    setNotif({
      title: payload?.notification?.title || "إشعار جديد",
      body: payload?.notification?.body || "",
    });
    setTimeout(() => setNotif(null), 8000);
  });
}, [dispatch, userId]);

    if (user?.role?.toLowerCase() === 'admin') {
        return <Navigate to="/dashboard" />;
    }

    return (
        <div className="relative" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
            <Navbar />
            <ScrollToTop />
            <Outlet />
            <Footer />
            {notif && (
        <NotificationPopup
          title={notif.title}
          body={notif.body}
          onClose={() => setNotif(null)}
        />
      )}
        </div>
    );
}

export default App;

